module.exports = __webpack_public_path__ + "static/media/espgg.8caf3b81.jpg";